import "./Footer.css";

const SOCIAL = [
  {
    name: "Facebook",
    href: "#",
    icon: (
      <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
    ),
  },
  {
    name: "Instagram",
    href: "#",
    icon: (
      <>
        <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
        <path
          d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"
          style={{ fill: "none", stroke: "#d4af37", strokeWidth: 2 }}
        />
        <line
          x1="17.5"
          y1="6.5"
          x2="17.51"
          y2="6.5"
          style={{
            fill: "none",
            stroke: "#d4af37",
            strokeWidth: 2,
            strokeLinecap: "round",
          }}
        />
      </>
    ),
  },
  {
    name: "WhatsApp",
    href: "https://wa.me/923000000000",
    icon: (
      <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
    ),
  },
  {
    name: "YouTube",
    href: "#",
    icon: (
      <>
        <path d="M22.54 6.42a2.78 2.78 0 0 0-1.95-1.96C18.88 4 12 4 12 4s-6.88 0-8.59.46a2.78 2.78 0 0 0-1.95 1.96A29 29 0 0 0 1 12a29 29 0 0 0 .46 5.58A2.78 2.78 0 0 0 3.41 19.6C5.12 20 12 20 12 20s6.88 0 8.59-.46a2.78 2.78 0 0 0 1.95-1.95A29 29 0 0 0 23 12a29 29 0 0 0-.46-5.58z" />
        <polygon
          points="9.75 15.02 15.5 12 9.75 8.98 9.75 15.02"
          style={{ fill: "#000" }}
        />
      </>
    ),
  },
  {
    name: "TikTok",
    href: "#",
    icon: (
      <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 0 0-.79-.05 6.34 6.34 0 0 0-6.34 6.34 6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.33-6.34V8.69a8.18 8.18 0 0 0 4.78 1.52V6.76a4.85 4.85 0 0 1-1.01-.07z" />
    ),
  },
];

const QUICK_LINKS = [
  { label: "Home", href: "#home" },
  { label: "About Us", href: "#about" },
  { label: "How It Works", href: "#how-it-works" },
  { label: "Project Locations", href: "#projects" },
  { label: "FAQ", href: "#faq" },
  { label: "Join Now", href: "#join" },
];

const LEGAL_LINKS = [
  { label: "Terms & Conditions", href: "#" },
  { label: "Privacy Policy", href: "#" },
  { label: "Refund Policy", href: "#" },
  { label: "Disclaimer", href: "#" },
  { label: "Investment Risk", href: "#" },
  { label: "Cookie Policy", href: "#" },
];

const CONTACT = [
  {
    icon: "📍",
    label: "Head Office",
    value: (
      <>
        Office #114, Plot no C9 B1 Sauleh Chamber Main Avenu,
        <br />
        S.I.T.E Aria, Karachi
      </>
    ),
  },
  {
    icon: "📧",
    label: "Email",
    value: <a href="mailto:support@growbizintl.com">info@growbizint.com</a>,
  },
  // {
  //   icon: "💬",
  //   label: "WhatsApp",
  //   value: <a href="https://wa.me/923000000000">+92-300-GROWBIZ</a>,
  // },
  {
    icon: "🕐",
    label: "Hours",
    value: (
      <>
        Mon – Sat: 9am – 7pm
        <br />
        Sun: 11am – 4pm
      </>
    ),
  },
];

export default function Footer2() {
  return (
    <footer className="ft-footer">
      <div className="ft-glow ft-glow1" />
      <div className="ft-glow ft-glow2" />

      {/* Newsletter strip */}
      <div className="ft-newsletter">
        <div className="ft-news-text">
          <h4>Stay Updated</h4>
          <p>Get the latest investment opportunities and earnings updates.</p>
        </div>
        <div className="ft-news-form">
          <input type="email" placeholder="Enter your email address" />
          <button>Subscribe</button>
        </div>
      </div>

      {/* Main grid */}
      <div className="ft-main">
        {/* Brand */}
        <div className="ft-brand">
          <div className="ft-logo">
            <div className="ft-logo-circle">G</div>
            <div className="ft-logo-text">
              Grow Biz
              <span>International</span>
            </div>
          </div>
          <p className="ft-tagline">
            Pakistan's most trusted real estate portfolio management and
            platform — empowering thousands to build wealth together.
          </p>
          <div className="ft-social">
            {SOCIAL.map((s) => (
              <a
                key={s.name}
                href={s.href}
                className="ft-soc-btn"
                title={s.name}
                target="_blank"
                rel="noreferrer"
              >
                <svg viewBox="0 0 24 24" fill="#d4af37" width="16" height="16">
                  {s.icon}
                </svg>
              </a>
            ))}
          </div>
        </div>

        {/* Quick Links */}
        <div>
          <div className="ft-col-title">Quick Links</div>
          <nav className="ft-links">
            {QUICK_LINKS.map((l) => (
              <a key={l.label} href={l.href}>
                {l.label}
              </a>
            ))}
          </nav>
        </div>

        {/* Legal */}
        <div>
          <div className="ft-col-title">Legal</div>
          <nav className="ft-links">
            {LEGAL_LINKS.map((l) => (
              <a key={l.label} href={l.href}>
                {l.label}
              </a>
            ))}
          </nav>
        </div>

        {/* Contact */}
        <div>
          <div className="ft-col-title">Contact Us</div>
          {CONTACT.map((c) => (
            <div key={c.label} className="ft-contact-item">
              <div className="ft-contact-icon">{c.icon}</div>
              <div>
                <div className="ft-contact-label">{c.label}</div>
                <div className="ft-contact-val">{c.value}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="ft-divider" />

      {/* Bottom bar */}
      <div className="ft-bottom">
        <p className="ft-copy">
          © 2026 <span>Grow Biz International</span>. All rights reserved.
        </p>
        <div className="ft-legal">
          <a href="#">Terms & Conditions</a>
          <a href="#">Privacy Policy</a>
          <a href="#">Disclaimer</a>
          <a href="#">Sitemap</a>
        </div>
      </div>
    </footer>
  );
}
